import { formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { LoanDetailsCard } from '../fixFlip/loanDetailsCard';
import { LoanDetailsCardProps } from '../fixFlip/summaryStep';
import { StabilizedBridgeLoanEconomicsStore } from '../../stores/stabilizedBridge/stabilizedBridgeLoanEconomicsStore';

export const StabilizedBridgeLoanDetailsCard = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_StabilizedBridgeLoanDetailsCard store={store} showAccordion={true} />;
  }
);
export const StabilizedBridgeLoanDetailsCardNoAccordion = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_StabilizedBridgeLoanDetailsCard store={store} showAccordion={false} />;
  }
);

const _StabilizedBridgeLoanDetailsCard = observer(
  ({
    store,
    showAccordion,
  }: LoanDetailsCardProps & { showAccordion: boolean }) => {
    const economicStore = (store.loanEconomicsStore as StabilizedBridgeLoanEconomicsStore);

    const keyRatios = economicStore.calculateKeyRatios();

    return (
      <LoanDetailsCard
        store={store}
        keyRatios={`${keyRatios}`}
        showAccordion={showAccordion}
        keyRatiosTooltip={
          economicStore.isLTC() ? 'LTC Purchase Price' : 'LTV Market Value'
        }
      />
    );
  }
);
